<template> 
  
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <Header />
    <b-container fluid="">
      <b-row v-if="titulo !== undefined" class="titulo">
        <b-col class="seccionTitulo">
          <span  class="fa fa-credit-card"></span>
          <span>Alineadores</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div >DX_</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">
          Bandeja Alineadores
        </b-col>
      </b-row>
 
      <b-row>
        <b-col cols="12">
          <validation-observer ref="observer" v-slot="{ handleSubmit }">
            <b-form
              inline
              @submit.stop.prevent="handleSubmit(buscar)"
            >
              <b-col cols="3" class="mt-3">
                <label>Alineador:</label>
                <validation-provider
                    name="validacionTipoalineador"
                    :rules="{ required: false }"
                    v-slot="slotTipoAlineador"
                >
                  <v-select
                      v-if="$localStorageService.can('Alineador_selec')"
                      id="alineador"
                      name="alineador"
                      placeholder="--Todos--"
                      :options="lstAlineadores"
                      :reduce="(item) => item.idTratamiento"
                      v-model="idAlineador"
                      label="nombre"
                      style="width: 100%"
                  >
                    <span slot="no-options">--Todos--</span>
                  </v-select>
                  <validacion
                      :texto="slotTipoAlineador.errors[0] ? slotTipoAlineador.errors[0] : ''"
                  ></validacion>
                </validation-provider>
              </b-col>
              <b-col cols="2" class="mt-3">
                <label>Fecha Inicio:</label>
                <validation-provider
                  name="validacionfechaInicio"
                  :rules="{ required: false }"
                  v-slot="slotFechaInicio"
                >
                  <b-input-group>
                    <b-form-datepicker
                      v-if="$localStorageService.can('Alineador_fechas')"
                      reset-button
                      inline
                      v-model="fechaI"
                      placeholder="Selecciona una fecha"/>
                    <template #append>
                      <b-btn v-if="fechaI!=null" @click="fechaI = null"  title="Limpiar">
                        <b-icon icon="x"></b-icon>
                      </b-btn>
                    </template>
                  </b-input-group>
                  <validacion
                      :texto="slotFechaInicio.errors[0] ? slotFechaInicio.errors[0] : ''"
                  ></validacion>
                </validation-provider>
              </b-col>
              <b-col cols="2" class="mt-3">
                <label>Fecha Fin:</label>
                <validation-provider
                  name="validacionfechaFin"
                  :rules="{ required: false }"
                  v-slot="slotFechaFin"
                >
                  <b-input-group>
                    <b-form-datepicker
                      v-if="$localStorageService.can('Alineador_fechas')"
                      v-model="fechaF"
                      placeholder="Selecciona una fecha"
                      reset-button/>
                    <template #append>
                      <b-btn v-if="fechaF!=null" @click="fechaF = null" title="Limpiar">
                        <b-icon icon="x"></b-icon>
                      </b-btn>
                    </template>
                  </b-input-group>
                  <validacion
                    :texto="slotFechaFin.errors[0] ? slotFechaFin.errors[0] : ''"
                  ></validacion>
                </validation-provider>
              </b-col>
              <b-col cols="2" class="mt-3">
                <label>Id Paciente:</label>
                <validation-provider
                    name="validacionIdPaciente"
                    :rules="{ required: false }"
                    v-slot="slotIdPaciente"
                    style="width: 100%"
                >
                  <b-input-group>
                    <b-form-input
                        v-if="$localStorageService.can('Alineador_Px')"
                        placeholder="ID del paciente"
                        v-model="idPaciente"
                    ></b-form-input>
                    <template #append>
                      <b-btn v-if="idPaciente!=null" @click="idPaciente = null" title="Limpiar">
                        <b-icon icon="x"></b-icon>
                      </b-btn>
                    </template>
                  </b-input-group>
                  <validacion
                      :texto="slotIdPaciente.errors[0] ? slotIdPaciente.errors[0] : ''"
                  ></validacion>
                </validation-provider>
              </b-col>
              <b-col cols="3" class="mt-4 d-flex align-items-center" style="height: 50px">
                <b-button class="p-1 m-0 w-50" v-if="$localStorageService.can('Alineador_bt_buscar')" size="md" block variant="outline-primary" type="submit" 
                  >Buscar</b-button
                >
                <b-button class="p-1 m-0 w-50 ml-3" v-if="idPaciente != null || fechaF != null || fechaI != null || idAlineador != null || clinicas.length > 0" @click="limpiarFiltros()" size="md" block variant="outline-primary"
                  >Limpiar filtros</b-button
                >
              </b-col>
              <b-col cols="6">
                <label>Clínica:<validacion/></label>
                    <b-container>
                      <b-row style="width: 100%">
                        <b-col cols="11">
                          <v-select style="width: 100%" :clearable="false" :options="listaClinicas"
                                    v-model="clinicas"
                                    :reduce="(variable) => variable.idClinica"
                                    label="nombreClinica" placeholder="Selecciona una clínica" multiple>
                            <span slot="no-options">No hay clínicas disponibles</span>
                          </v-select>
                        </b-col>
                        <b-col cols="1" class="d-flex" style="height: 50px;">
                          <b-button
                              class="ml-1"
                              variant="outline-primary"
                              v-b-tooltip.hover
                              title="Seleccionar todas"
                              @click="seleccionarTodasClinicas()">
                            <b-icon icon="check2-all"></b-icon>
                          </b-button>
                          <b-button v-if="clinicas!==undefined && clinicas!==null && clinicas.length > 0"
                                  class="ml-1"
                                  variant="outline-danger"
                                  v-b-tooltip.hover
                                  title="Quitar selección"
                                  @click="deSeleccionarTodasClinicas()" size="md">
                          <b-icon icon="trash-fill"></b-icon>
                        </b-button>
                        </b-col>
                      </b-row>
                    </b-container>
              </b-col>
            </b-form>
          </validation-observer>
        </b-col>
      </b-row>

      <b-row v-if="cifrasControl !== undefined" class="mt-5">
        <template  v-for="cifra in cifrasControl" >
          <b-col v-if="cifra.visible && cifra.nombre != 'Cancelado'" :key="cifra.id">
            <p class="letraMayusculaMinuscula">
              <b-icon :icon="cifra.icono"></b-icon>
              {{ cifra.nombre }} {{ cifra.cantidad }}
            </p>
          </b-col>
        </template>
      </b-row>

      <b-row v-if="cifrasControl !== undefined">
        <b-col cols="12">
          <br />
          <b-tabs>
            <template v-for="cifra in cifrasControl">
              <b-tab
              v-if="(cifra.visible) && ((cifra.nombre == 'Pendiente' && $localStorageService.can('Alineador_Pendiente')) || 
              (cifra.nombre == 'Solicitado' && $localStorageService.can('Alineador_Solicitado')) ||
              (cifra.nombre == 'Entregado' && $localStorageService.can('Alineador_Entregado')) ||
              (cifra.nombre == 'Cancelado' && $localStorageService.can('Alineador_Cancelado')))"
              :key="cifra.id"
              :title="cifra.nombre"
              @click="buscar(cifra.id, 'tab')"
            >

              <b-table
               :key="paginaActual"
                :items="datosTabla"
                :fields="cifra.layoutTabla"
                responsive
                :per-page="registrosPorPagina"
                
              >
                <template #cell()="data">
                  <div
                    :is="data.field.component"
                    :data="data" 
                    @_funcionExtra="buscar(cifra.id, 'desde tabla')"
                    v-if="data.field.component !== undefined"
                    :resource="resource"
                  ></div>
                  <span v-else>{{ data.value }}</span>
                </template>
                <template v-slot:cell(nombreTipoSolicitudAnterior)="row">
                  <b-badge variant="primary">
                    {{ row.item.nombreTipoSolicitudAnterior }}
                  </b-badge>
                </template>
              </b-table>
      
              <b-pagination  
                v-if="datosTabla !== undefined && cifra.cantidad > 20"
                align="center"
                v-model="paginaActual"
                :total-rows="totalRouws"
                :per-page="registrosPorPagina"
                @change="paginaCambiada"
              ></b-pagination>
            </b-tab>
            </template>
          </b-tabs>
        </b-col>
      </b-row>

      <b-row class="mb-5"/>
    </b-container>
  </div>
</template>

<script> 
import Header from "../../components/Header.vue";

export default {
  name: "BandejaInvasiling",
  components: { 
    Header,
  },
  props: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    clinicas: [],
    listaClinicas: [],
    paginaActual: 1,
    registrosPorPagina: 20,
    totalRouws: 0,
    idBandeja: 1,
    loading: false,
    idEmpleado: null,
    idClinica: null,
    idUsuario: null,
    arrayDatosPtisServicio: [],
    datosTabla: [],

    encabezados: [],

    cifrasControl: [
      {
        id: 1,
        nombre: "Pendiente",
        cantidad: 0,
        icono: "",
        layoutTabla: [],
        visible:false,
      },
      {
        id: 2,
        nombre: "Solicitado",
        cantidad: 0,
        icono: "",
        layoutTabla: [],
        visible:false,
      },
      {
        id: 4,
        nombre: "Entregado",
        cantidad: 0,
        icono: "",
        layoutTabla: [],
        visible:false,
      },
      {
        id: 3,
        nombre: "Cancelado",
        cantidad: 0,
        icono: "",
        layoutTabla: [],
        visible:false,
      }
    ],
    icono: "fa fa-credit-card",
    titulo: "DENTAL",
    codigoTitulo: "BJ_invisalign_01",
    resource: {
      idEstatusSolicitud: null
    },
    idClasificacionPestaniaSeleccionada: 1,
    lstAlineadores: [],

    idAlineador: null,
    fechaI: null,
    fechaF: null,
    idPaciente: null,
    
    
  }),
  
  methods: {
    deSeleccionarTodasClinicas() {
      this.clinicas = [];
    },
    limpiarFiltros(){
      this.idPaciente = null;
      this.fechaF = null;
      this.fechaI = null;
      this.idAlineador = null;
      this.clinicas = [];
    },

    llenarClinicas() {
      this.listaClinicas = this.$localStorageService.getClinicas();
    },
    seleccionarTodasClinicas() {
      this.clinicas = this.listaClinicas.map(item => item.idClinica);
    },
    paginaCambiada(pagina) {
    this.paginaActual = pagina;
    this.getObtenerDatosBandeja(pagina);
  },
    getAlineadores() {

      this.lstAlineadores = [];

      this.$http
          .post(
              this.$api +
              "invisalign/obtenerTratamientosAlineador", {}
          )
          .then((response) => {
           this.lstAlineadores = response.data.data;
          })
          .catch((error) => {
            console.log(error);
          });
    },
    getObtenerDatosBandeja(pagina) {
      this.paginaActual = pagina;
      this.loading = true;
      this.arrayDatosPtisServicio = [];
      this.datosTabla = [];
      const clinicasUsuario = this.listaClinicas.map(item => item.idClinica);


      const parametros = {
        idAlineador: this.idAlineador,
        idPaciente: this.idPaciente,
        idEstatus: this.idClasificacionPestaniaSeleccionada,
        fechaInicio: this.procesarFecha(this.fechaI, true),
        fechaFinal: this.procesarFecha(this.fechaF, false),
        paginaActual: pagina,
        clinicas: this.clinicas.length > 0 && this.clinicas != null ? this.clinicas : clinicasUsuario
      }
      this.$http
        .post(
          this.$api +
            "invisalign/obtenerDatosBandeja",
            parametros
        )
        .then((response) => {
          //NO devuelve un array asi que no funciona validar isArray
          this.resource.idEstatusSolicitud = this.idClasificacionPestaniaSeleccionada;
          this.arrayDatosPtisServicio = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        })
        .finally(() =>{
            this.procesarDatos();
            this.getCifrasPorEstatus();
          } 
        );
    },
    procesarFecha(fecha, inicio){
      if (fecha == null) {
        return null;
      }
      var dia = new Date(fecha);
      dia.setDate(dia.getDate() + 1);
      if (inicio) {
        dia.setHours(0, 0, 0, 0);
      } else {
        dia.setHours(23, 60, 59, 999);
      }
      return this.$moment(dia).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    },
    procesarDatos() { 
      this.datosTabla = [];
      if (this.arrayDatosPtisServicio.length > 0) {
        
        this.arrayDatosPtisServicio.forEach((elemento) => {

          this.datosTabla.push({
            idBandejaInvisaling: elemento.idBandejaInvisaling,
            nombrePaciente: elemento.nombrePaciente,
            idPaciente: elemento.idPaciente,
            idPti: elemento.idPti,
            nombreClinica: elemento.nombreClinica,
            idTxInvisaling: elemento.idTxInvisaling,
            txInvisaling: elemento.txInvisaling,
            fechaPago: elemento.fechaPago,
            fechaSolicitud: elemento.fechaSolicitud,
            fechaRegistroERP: elemento.fechaRegistroERP,
            montoPagado: elemento.montoPagado,
            numPacienteInvisaling: elemento.numPacienteInvisaling,
            noRecibo: elemento.noRecibo,
          });
        });
      }
      console.log("this.arrayDatosPtisServicio",this.arrayDatosPtisServicio)
      console.log("this.datosTabla",this.datosTabla)
        this.loading = false;
    }, 

    getCifrasPorEstatus() {
     const pagina = this.paginaActual;
      this.cifrasControl[0].cantidad = 0;
      this.cifrasControl[0].layoutTabla = this.encabezados;
      this.cifrasControl[1].cantidad = 0;
      this.cifrasControl[1].layoutTabla = this.encabezados;
      this.cifrasControl[2].cantidad = 0;
      this.cifrasControl[2].layoutTabla = this.encabezados;
      this.cifrasControl[3].cantidad = 0;
      this.cifrasControl[3].layoutTabla = this.encabezados;
      this.totalRouws = 0;

      const clinicasUsuario = this.listaClinicas.map(item => item.idClinica);

      const parametros = {
        idAlineador: this.idAlineador,
        idPaciente: this.idPaciente,
        fechaInicio: this.procesarFecha(this.fechaI, true),
        fechaFinal: this.procesarFecha(this.fechaF, false),
        clinicas: this.clinicas.length > 0 && this.clinicas != null ? this.clinicas : clinicasUsuario
      }
      
      this.$http
        .post(
          this.$api +
            "invisalign/cifrasPorEstatus", parametros
        )
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            var data = response.data.data;
            this.totalRouws = 0;
            data.forEach((elemento) => {
              if (elemento.idEstatusSolicitud == 1) {
                this.cifrasControl[0].cantidad = elemento.noTotalSolcitudes;
                this.cifrasControl[0].layoutTabla = this.encabezados;
                if(this.idClasificacionPestaniaSeleccionada == 1){
                  this.totalRouws = elemento.noTotalSolcitudes;
                }
              }
              if (elemento.idEstatusSolicitud == 2) {
                this.cifrasControl[1].cantidad = elemento.noTotalSolcitudes;
                this.cifrasControl[1].layoutTabla = this.encabezados;
                if(this.idClasificacionPestaniaSeleccionada == 2){
                  this.totalRouws = elemento.noTotalSolcitudes;
                }
              }
              if (elemento.idEstatusSolicitud == 4) {
                this.cifrasControl[2].cantidad = elemento.noTotalSolcitudes;
                this.cifrasControl[2].layoutTabla = this.encabezados;
                if(this.idClasificacionPestaniaSeleccionada == 4){
                  this.totalRouws = elemento.noTotalSolcitudes;
                }
              }
              if (elemento.idEstatusSolicitud == 3) {
                this.cifrasControl[3].cantidad = elemento.noTotalSolcitudes;
                this.cifrasControl[3].layoutTabla = this.encabezados;
                if(this.idClasificacionPestaniaSeleccionada == 3){
                  this.totalRouws = elemento.noTotalSolcitudes;
                }
              }
            });
          }
        })
        .catch((error) => {
          console.log(error);
        }).finally(() =>{
          this.paginaActual = pagina;
          } 
        );
    }, //  ----------------------------


    buscar(idClasificacion) {
      if (idClasificacion != null) {
        this.idClasificacionPestaniaSeleccionada = idClasificacion;
      }

      this.actualizarEncabezados();


      this.getObtenerDatosBandeja(1);
    },

    actualizarEncabezados() {
      this.encabezados = [
        {
          key: "fechaSolicitud",
          label: "Fecha Pago",
          sortable: true,
          component: "BandejaFechaTextoComponente",
        },
        {
          key: "noRecibo",
          label: "Recibo",
          sortable: true,
        },
        {
          key: "montoPagado",
          label: "Monto Pagado",
          sortable: true,
        },
        {
          key: "nombrePaciente",
          label: "Paciente",
          sortable: true,
          component: "LinkPacientePerfilComponente",
        },
        {
          key: "idPaciente",
          label: "ID Paciente",
          sortable: true,
        },
        {
          key: "idPti",
          label: "PTI",
          sortable: true,
        },
        {
          key: "nombreClinica",
          label: "Clínica",
          sortable: true,
        },
        {
          key: "idTxInvisaling",
          label: "ID Tx",
          sortable: true,
        },
        {
          key: "txInvisaling",
          label: "Tx",
          sortable: true,
        }
      ];
      //
      // if ([2,3].indexOf(this.idClasificacionPestaniaSeleccionada) > -1) {
      //
      // }

      if (this.idClasificacionPestaniaSeleccionada == 2) {
        this.encabezados.push(
            {
              key: "numPacienteInvisaling",
              label: "Paciente #",
              sortable: true,
            },
        );
        this.encabezados.push(
            {
              key: "fechaRegistroERP",
              label: "Registro ERP",
              sortable: true,
              component: "BandejaFechaTextoComponente",
            }
        );
        this.encabezados.push({
          key: "entregar",
          label: "Entregar",
          sortable: false,
          component: "BandejaInvisalingComponenteEntregar",
        });
      }

      if (this.idClasificacionPestaniaSeleccionada == 1) {
        this.encabezados.push({
          key: "capturar",
          label: "Capturar",
          sortable: false,
          component: "BandejaInvisalingComponenteCapturar",
        });
      }

    }
    
  },
  mounted() {

    if (this.$localStorageService.can('BJ_invisalign_Cancelado')) {
      this.cifrasControl[3].visible= true;
      this.idClasificacionPestaniaSeleccionada= 4;
    }

    if (this.$localStorageService.can('BJ_invisalign_Entregado')) {
      this.cifrasControl[2].visible= true;
      this.idClasificacionPestaniaSeleccionada= 3;
    }

    if (this.$localStorageService.can('BJ_invisalign_Proceso')) {
      this.cifrasControl[1].visible= true;
      this.idClasificacionPestaniaSeleccionada= 2;
    }

    if (this.$localStorageService.can('BJ_invisalign_Pediente')) {
      this.cifrasControl[0].visible= true;
      this.idClasificacionPestaniaSeleccionada= 1;
    }



    this.buscar();
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.llenarClinicas();
    this.getAlineadores();
    this.resource = {
      idEstatusSolicitud: null,
      arrayEspecialidades: [],
      arrayEspecialistas: [],
    };
    this.idEmpleado = this.$localStorageService.getIdEmpleado();
    this.idClinica = this.$localStorageService.getIdClinica();
    this.idUsuario = this.$localStorageService.getIdUsuario();
    this.buscar();
  },
  computed: {
 
  },  
  watch: { 
    /* paginaActual() {
      this.getObtenerDatosBandeja();
    }, */
  },
};
</script>
